module.exports = __webpack_public_path__ + "static/media/BM.762ad712.png";